// extracted by mini-css-extract-plugin
export default {"main":"b2a898e9af _5646a134d4 _8cfa278557 _33a1b90b41","title":"b84e3ef7b0"};